import AclName from '../AclName.js';

export default [
  AclName.BookkeepingPageInvoicesAdd,
  AclName.BookkeepingPageInvoicesCorrectionAdd,
  AclName.BookkeepingPageInvoicesCorrectionEdit,
  AclName.BookkeepingPageInvoicesEdit,
  AclName.BookkeepingPageInvoicesList,
  AclName.BookkeepingPageInvoicesPaymentDueList,

  AclName.CrmBtnCrmDelete,
  AclName.CrmBtnCrmEdit,
  AclName.CrmBtnCreateCrm,
  AclName.CrmBtnBalancePayment,
  AclName.CrmBtnSendMail,
  AclName.CrmSectionSystemBalanceDocuments,

  AclName.CrmPageCrmAdd,
  AclName.CrmPageCrmEdit,
  AclName.CrmPageCrmList,
  AclName.CrmPageAgreementReview,

  AclName.FilesPageFilesList,
  AclName.FilesPageFilesFormAdd,
  AclName.FilesPageFilesFormEdit,

  AclName.FilesBtnFilesMergeFiles,
  AclName.FilesBtnFilesSplitFile,
  AclName.FilesBtnFilesDelete,
  AclName.FilesBtnFilesAdd,
  AclName.FilesBtnFilesEdite,
  AclName.FilesBtnFilesDocumentsProvided,

  AclName.SettingsPageTemplatesInvoiceDescriptionsList,
  AclName.SettingsPageTemplatesInvoiceDescriptionsEdit,

  AclName.SettingsBtnInvoiceTemplateNumberDelete,
  AclName.SettingsBtnInvoiceTemplateNumberChangeNumber,
  AclName.SettingsPageInvoiceTemplateNumberList,
  AclName.SettingsPageInvoiceTemplateNumberAdd,
  AclName.SettingsPageInvoiceTemplateNumberChangeNumber,

  AclName.SettingsPageSubscriptionOrdersList,
  AclName.SettingsPageSystemBalancesList,

  AclName.BookkeepingInvoicesAccessAll,

  AclName.CrmPageBillingSettle,

  AclName.CrmPageMailingList,
  AclName.CrmPageMailingStepper,
  AclName.CrmBtnMailingDelete,
  AclName.CrmBtnMailingEdit,
  AclName.CrmBtnMailingSendNow,
  AclName.MailingSettingsBtnSave,
  AclName.MailingAdmin,
];
